module.exports = __webpack_public_path__ + "static/media/historicoMarcaPonto.ec911689.jpg";